module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clipboard":"Copied to Clipboard","title":"Edit properties"},"fr":{"clipboard":"Copié vers le presse-papier","title":"Modifier les propriétés"}}')
  delete Component.options._Ctor
}
